
import {Component, Vue} from "vue-property-decorator";
import {formRules} from "@/utils/formRules";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiNfcVariant } from "@mdi/js";
import { readNfcData, scanNfc } from "@/services/nfc";
import { Getter } from "vuex-class";
import Store from "@/store";
import router from "@/router";

@Component({
  components: {
    SvgIcon,
  },
})
export default class Login extends Vue {

    private form: any = {
        phoneOrEmail: "",
        password: "",
    };
    private rules: object = formRules;
    private valid: boolean = true;
    private loading: boolean = false;
    private showPassword: boolean = false;
    private forgottenPasswordState: boolean = false;
    private mdiNfcVariant: any = mdiNfcVariant;
    private nDEFReaderInWindow: boolean = false;
    private scanningNfc: boolean = false;
    private hasPassword: boolean = false;

    @Getter private browserVersion: string;

    get networkError() {
      return this.$store.state.networkError;

    }

    private mounted() {
        this.nDEFReaderInWindow = "NDEFReader" in window;
    }
    private preLogin() {
      this.loading = true;
      this.$store.dispatch("auth/preLogin", {
          phoneOrEmail: this.form.phoneOrEmail,
      }).then((data) => {
        this.hasPassword = data.hasPassword;
        if (!this.hasPassword) {
          this.$store.commit("alerts/displaySuccess", {
              msg: this.$t("alerts.error.noPassWord", {type : data.connectedBy}),
          });
        }
      }).catch((err) => {
        this.$store.commit("alerts/displayError", {
              msg: this.$t(`alerts.error.${err.response.data.message}`),
          });
      }).finally(() => {
        this.loading = false;
      });
    }

  private login() {
    this.loading = true;
    this.$store.dispatch("auth/loginWithCredential", {
      login: this.form.phoneOrEmail,
      password: this.form.password,
    }).then(() => {
      router.push({ name: "home" });
    }).catch((err) => {
      this.loading = false;
      this.$store.commit("alerts/displayError", {
        msg: this.$t(`alerts.error.${err.response?.data?.error}`),
      });
    });
  }


    private async logByNfc() {
        if (this.scanningNfc === false) {
        const abortController = new AbortController();
        this.scanningNfc = true;
        try {
          const nfcData = await scanNfc(abortController);
          const dataDecoded = readNfcData(nfcData);
          // tslint:disable-next-line:no-console
          const jwt = dataDecoded?.records[0]?.data;
          if (jwt) {
            this.$store.dispatch("auth/loginWithNfc", jwt).catch((err) => {
              this.$store.commit("alerts/displayError", {
                msg: this.$t(`Login.${err.response.data.message}`),
              });
            });
          }
        } catch (error) {
          // tslint:disable-next-line:no-console
          console.error(error);
        }
        this.scanningNfc = false;
      }
    }

    private keyDownEvent(e: KeyboardEvent) {
      if (e.key === "Enter") {
        if (this.forgottenPasswordState && this.form.phoneOrEmail) {
          this.forgottenPasswordFn();
        } else if (!this.forgottenPasswordState && this.hasPassword && this.valid) {
          this.login();
        } else if (!this.hasPassword) {
          this.preLogin();
        }
      }
    }

    private forgottenPasswordSwitch() {
        this.forgottenPasswordState = !this.forgottenPasswordState;
    }

    private forgottenPasswordFn() {
      this.loading = true;
      this.$store.dispatch("public/password/forgottenPassword", {
          email: this.form.phoneOrEmail,
        }).then(() => {
          this.$store.commit("alerts/displaySuccess", {
            msg: this.$i18n?.t("login.retrieveMail"),
          });
        }).catch((err) => {
          this.$store.commit("alerts/displayError", {
            msg: this.$i18n?.t(`alerts.error.${err?.response?.data?.error || "default"}`),
          });
        }).finally(() => {
          this.loading = false;
        });
    }
}
